import { FAQ_ITEMS } from "@/constants/testIds";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FAQ() {
  return (
    <div>
      <section className="section-pad pb-8 bg-offwhite pt-32">
        <div className="container-editorial grid md:grid-cols-12 gap-10">
          <aside className="md:col-span-4">
            <div className="eyebrow text-teal mb-4"><span className="editorial-rule" /> Frequently Asked</div>
            <h1 className="font-display text-forest text-5xl md:text-6xl leading-[0.98]">
              The paperwork,<br />the plot,<br />the plan.
            </h1>
            <p className="mt-6 text-forest/70 leading-relaxed max-w-md">
              The questions Phase I and Phase II buyers asked, in the order they
              asked them. Anything below that leaves an open thread —{" "}
              <Link className="underline underline-offset-4" to="/contact">book a call</Link>.
            </p>
          </aside>
          <div className="md:col-span-8">
            <Accordion type="single" collapsible className="border-t border-forest/15">
              {FAQ_ITEMS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-forest/15"
                >
                  <AccordionTrigger className="text-left py-6 text-forest hover:no-underline font-display text-xl md:text-2xl">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-forest/80 text-[15px] leading-relaxed pb-6 pr-8">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>

      <section className="section-pad bg-forest text-cream">
        <div className="container-editorial flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <h2 className="font-display text-4xl md:text-5xl leading-tight max-w-xl">
            Some questions are easier<br />answered on a 30-min video call.
          </h2>
          <Link to="/strategy-call" className="btn-primary">Book Online Consultation →</Link>
        </div>
      </section>
    </div>
  );
}
